import { Col } from 'antd';
import React, { useEffect, useState } from 'react';

import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import AkcionarCard from 'components/molecules/Akcionar/AkcionarCard';

import prehledKorporatniAkceApi, { ISezudalostiKorporatniAkce } from 'services/korporatniAkce/prehledKorporatniAkce';

interface PrehledKorporatniAkceProps {}

export const PrehledKorporatniAkce: React.FC<PrehledKorporatniAkceProps> = () => {
    const [prehled, setPrehled] = useState<ISezudalostiKorporatniAkce[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [reload, setReload] = useState<boolean>(false);
    useEffect(() => {
        setLoading(val => !val);
        prehledKorporatniAkceApi()
            .then(resp => setPrehled(resp))
            .finally(() => setLoading(val => !val));
    }, []);
    // Effect pro prenacteni hodnoty pri smazani dlazdice
    useEffect(() => {
        if (reload) {
            setLoading(val => !val);
            prehledKorporatniAkceApi()
                .then(resp => setPrehled(resp))
                .finally(() => {
                    setReload(false);
                    setLoading(val => !val);
                });
        }
    }, [reload]);

    return (
        <LoadingWrapper loading={loading}>
            <Title level={3} text={'SRD_DLAZDICE_NADPIS_SEZNAM'} />
            <Col span={16}>
                <AkcionarCard prehled={prehled} pocetDlazdic={99} reload={setReload} />
            </Col>
        </LoadingWrapper>
    );
};
